import { create } from 'zustand';
import { io } from 'socket.io-client';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SOCKET_PATH = '/socket.io';

export const useSocketStore = create((set, get) => ({
  socket: null,
  isConnected: false,
  
  connect: (tenantId) => {
    const existingSocket = get().socket;
    if (existingSocket?.connected) {
      return;
    }
    
    const socket = io(BACKEND_URL, { 
      path: SOCKET_PATH,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000
    });
    
    socket.on('connect', () => {
      console.log('Socket connected');
      set({ isConnected: true });
      
      if (tenantId) {
        socket.emit('join_tenant', { tenant_id: tenantId });
      }
    });
    
    socket.on('disconnect', () => {
      console.log('Socket disconnected');
      set({ isConnected: false });
    });
    
    socket.on('connect_error', (error) => {
      console.log('Socket connection error:', error.message);
      set({ isConnected: false });
    });
    
    set({ socket });
  },
  
  disconnect: () => {
    const socket = get().socket;
    if (socket) {
      socket.disconnect();
      set({ socket: null, isConnected: false });
    }
  },
  
  subscribe: (event, callback) => {
    const socket = get().socket;
    if (socket) {
      socket.on(event, callback);
      return () => socket.off(event, callback);
    }
    return () => {};
  }
}));
